import { combineReducers } from "redux";
import widgetReducer from "./slices/master/widgetSlice";
import appsReducer from "./slices/master/appSlice";
import buttonReducer from "./slices/master/buttonSlice";
import commonReducer from "./slices/common/commonSlice";
import studentHelpReducer from "./slices/master/studentHelpSlice";
import notificationReducers from "./slices/master/notificationSlice";
import studentResourceReducer from "./slices/master/studentResourceSlice";
import departmentReducer from "./slices/master/departmentSlice";
import collegeReducer from "./slices/master/collegeSlice";
import snapShotReducer from "./slices/master/snapShotSlice";
import technologyResourceReducer from "./slices/master/technologyResourceSlice";
import mediaContentReducer from "./slices/master/mediaContentSlice";
import departmentResourceReducer from "./slices/master/departmentResource";
import reportReducer from "./slices/master/reportSlice";
import trainingBlockReducer from "./slices/master/trainingBlockSlice";
import trainingHelpReducer from "./slices/master/trainingHelpSlice";
import tasksReducer from "./slices/master/taskSlice";
import studentCourceDetailReducer from "./slices/student/studentCourceDetailSlice";
import notificationTypeReducers from "./slices/staff/staffNotificationSlice";
import facultyConnectDetailReducer from "./slices/faculty/facultyConnectSlice";
import staffConnectReducer from "./slices/staff/staffConnectSlice";
import trainingMatricsReducer from "./slices/staff/trainingCompletionDetailsSlice";
import academicProfilesReducer from "./slices/student/acradamicProfileSlice";
import studentAccountDetailReducer from "./slices/student/studentAccountDetailSlice";
import studentGradeDetailReducer from "./slices/student/studentGradeSlice";
import studentInfoReducer from "./slices/student/studentInfoSlice";
import studentTransactionReducer from "./slices/student/studentTransactions";
import userReducer from "./slices/user/userSlice";
import StudentFinancialAccountDetailReducer from "./slices/student/studentFinancialAccountDetails";
import studentEarlyAlertsReducer from "./slices/student/studentEarlyAlertsSlice";
import studentSubjectGradesReducer from "./slices/student/studentSubjectGrades";
import studentCurrentOpeningReducer from "./slices/student/studentCurrentOpeningSlice";
import eventDetailReducer from "./slices/common/studentEventsSlice";
import safetyAlertReducer from "./slices/common/campusSafetyAlertSlice";
import studentTermDetailReducer from "./slices/student/studentTermSlice";
import notificationCountReducers from "./slices/master/notificationCountSlice";
import facultyConnectClassDetailReducer from "./slices/faculty/facultyConnectClassSlice";
import calendarSlice from "./slices/common/calendarSlice";
import emailConfigurationReducer from "./slices/master/emailConfigurationSlice";
import workloadReducer from "./slices/faculty/facultyWorkloadSlice";
import descriptionReducer from "./slices/master/descriptionSlice";
import chatBotReducer from "./slices/common/chatBotSlice";
import mainStepReducer from "./slices/freshman/mainStepSlice";
import subStepReducer from "./slices/freshman/subStepSlice";
import freshmanProcessReducer from "./slices/freshman/freshmanProcessSlice";
import freshmanConfigurationReducers from "./slices/freshman/configurationSlice";
import inactiveVersionReducers from "./slices/freshman/inactiveVersionSlice";
import studentCourceRateDetailReducer from "./slices/student/studentCourseRateSlice";
import aiConfigurationReducer from "./slices/ai/aiConfigurationSlice";


const reducers = {
  widget: widgetReducer,
  app: appsReducer,
  common: commonReducer,
  button: buttonReducer,
  studentHelp: studentHelpReducer,
  studentResource: studentResourceReducer,
  notification: notificationReducers,
  notificationType: notificationTypeReducers,
  department: departmentReducer,
  college: collegeReducer,
  snapShot: snapShotReducer,
  technologyResource: technologyResourceReducer,
  mediaContent: mediaContentReducer,
  departmentResource: departmentResourceReducer,
  report: reportReducer,
  trainingBlock: trainingBlockReducer,
  trainingHelp: trainingHelpReducer,
  task: tasksReducer,
  studentCourceDetail: studentCourceDetailReducer,
  studentCourceRateDetail: studentCourceRateDetailReducer,
  studentAccountDetail: studentAccountDetailReducer,
  studentGradeDetail: studentGradeDetailReducer,
  staffConnect: staffConnectReducer,
  trainingMatrics: trainingMatricsReducer,
  academicDetail: academicProfilesReducer,
  facultyConnect: facultyConnectDetailReducer,
  facultyConnectClass: facultyConnectClassDetailReducer,
  studentInfo: studentInfoReducer,
  studentTransactionDetails: studentTransactionReducer,
  userDetails: userReducer,
  studentFinancailAccountDetail: StudentFinancialAccountDetailReducer,
  studentEarlyAlerts: studentEarlyAlertsReducer,
  studentSubjectGrades: studentSubjectGradesReducer,
  studentCurrentOpenings: studentCurrentOpeningReducer,
  eventDetail: eventDetailReducer,
  safetyAlertDetail: safetyAlertReducer,
  studentTermDetail: studentTermDetailReducer,
  notificationCount: notificationCountReducers,
  calendar: calendarSlice,
  emailConfiguration: emailConfigurationReducer,
  workload: workloadReducer,
  description: descriptionReducer,
  chatbot: chatBotReducer,
  mainStep: mainStepReducer,
  subStep : subStepReducer,
  freshmanProcess: freshmanProcessReducer,
  freshmanConfiguration : freshmanConfigurationReducers,
  inactiveVersion : inactiveVersionReducers,
  aiConfiguration: aiConfigurationReducer,
};

export const appReducer = combineReducers(reducers);
